/**
 * Translation constants for WordCloud
 */

export type TargetLanguage = 'en' | 'ko' | 'ja' | 'es' | 'fr' | 'de';

export interface LanguageOption {
  value: TargetLanguage;
  label: string;
  nativeLabel: string;
}

/**
 * order
 * en, ko, ja, es, fr, de
 */
export const TARGET_LANGUAGES: LanguageOption[] = [
  { value: 'en', label: 'English', nativeLabel: 'English' },
  { value: 'ko', label: 'Korean', nativeLabel: 'Korean' },
  { value: 'ja', label: 'Japanese', nativeLabel: '日本語' },
  { value: 'es', label: 'Spanish', nativeLabel: 'Español' },
  { value: 'fr', label: 'French', nativeLabel: 'Français' },
  { value: 'de', label: 'German', nativeLabel: 'Deutsch' },
];

export const DEFAULT_TARGET_LANGUAGE: TargetLanguage = 'en';
